// extracted by mini-css-extract-plugin
export default {"pillContainer":"pillContainerGLWo5"};